import React, { Fragment } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import history from "../history";
import FormCreatorV2 from "../common/FormCreatorV2";
import { submitUmbrellaDeclarationForm } from "../redux/actions";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../common/FormCreator/helpers";

const UmbrellaDeclaration = ({
  appData,
  submitUmbrellaDeclarationFormFunc,
}) => {
  const initialData = {
    Signature: `${appData.firstName} ${appData.lastName}`,
    DeclarationDate: moment().format("DD/MM/YYYY"),
  };

  const getVal = getField(initialData);

  const formCompleted = () => {
    const declarationFormComplete =
      appData.umbrellaDeclarationForm &&
      appData.umbrellaDeclarationForm.completed;
    return !!declarationFormComplete;
  };

  const initialState = {
    FormText: {
      htmlObj: (
        <div>
          <div>
            I confirm that I have opted to be paid via an FCSA accredited
            umbrella company, or equivalent international local body, that is
            currently an approved provider of HRGO Plc.
          </div>
          <div>I am fully aware that:</div>
          <ul>
            <li>
              HRGO Plc does not facilitate the use of umbrella companies unless
              it is in the interests of the candidate/contractor and that the
              company’s default option is in-house PAYE;
            </li>
            <li>
              The umbrella company will be my employer and HRGO will be my work
              finding service provider;
            </li>
            <li>
              The umbrella company, not HRGO, will charge me a fee for each
              timesheet that is processed;
            </li>
            <li>
              My assignment rate will differ from the rate I get paid as it will
              include all company costs associated with payroll, including
              deduction of the aforementioned fee.
            </li>
          </ul>
        </div>
      ),
    },
    Reason: {
      title:
        "Please state the reason why an umbrella is appropriate in your specific circumstances" +
        " (e.g. obtaining work finding services from more than one agency)",
      type: "textarea",
      value: getVal("Reason"),
      mandatory: true,
    },
    Signature: {
      type: "text",
      title: "Signature",
      value: getVal("Signature"),
      disabled: true,
    },
    DeclarationDate: {
      type: "text",
      title: "Date",
      value: getVal("DeclarationDate"),
      disabled: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const submitForm = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitUmbrellaDeclarationFormFunc({ ...fieldValuesPayload });
    history.push("/profile");
  };

  return (
    <Fragment>
      {formCompleted() ? (
        history.push("/profile")
      ) : (
        <FormCreatorV2
          formTitle={
            "Declaration of Understanding for an outsourced payroll option"
          }
          fields={fields}
          setField={setField}
          handleCancel={() => history.push("/profile")}
          handleSubmit={submitForm}
          useSubmitText={true}
        />
      )}
    </Fragment>
  );
};

UmbrellaDeclaration.propTypes = {
  appData: any,
  submitUmbrellaDeclarationFormFunc: func.isRequired,
};

const mapDispatchToProps = {
  submitUmbrellaDeclarationFormFunc: submitUmbrellaDeclarationForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(UmbrellaDeclaration);
